<template>
  <div>
    <div style="overflow-x: auto" v-if="showAppointmentResult">
      <div
        class="custom-div"
      >
        <app-heading
          :text="'NBN Appointment Deatils'"
          :heading="'main'"
        ></app-heading>
        <div ref="result" class="center">
          <div>
            <p class="custom-p text-right font-weight-bold" :class="addClass">
              Appointment Id:
            </p>
            <p class="custom-p">
              <span v-html="tier1"></span>{{ result.data.id }}
            </p>
          </div>

          <div>
            <p class="custom-p text-right font-weight-bold" :class="addClass">
              Appointment status:
            </p>
            <p class="custom-p">
              <span v-html="tier1"></span>{{ result.data.status }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "nbn-appointment-results",
  data: () => ({
    showAppointmentResult: false,
    tier1: "&nbsp;",
    result:{}
  }),
  methods: {
    addClass() {
      return "first-sq";
    },
  },
}
</script>

<style scoped>
.custom-div {
  border: 2px solid #9e9e9e;
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 15px;
  font-size: 15px !important;
}

.serviceable {
  border-color: #2cd375 !important;
}

.not-serviceable {
  border-color: #ee3923 !important;
}

.row-border {
  border-top: 1px solid #9e9e9e;
}

.custom-p {
  display: inline-block;
  margin-bottom: 2px;
}

.first-sq {
  width: 513px;
  margin-right: 10px;
  display: inline-block;
  vertical-align: top;
}

.first-order {
  width: 445px;
  margin-right: 10px;
  display: inline-block;
  vertical-align: top;
  width: 37%;
}

.center {
  margin: auto;
  width: 50%;
  border: 3px solid green;
  padding: 10px;
}

@media screen and (max-width: 1100px) {
  .custom-div {
    width: 1100px;
  }
}

</style>
